import React from 'react';
import { translate } from 'react-i18next';

import Button from '../common/button';
import SignedOutHeader from '../signin/signedOutHeader';

const SignIn = ({ t, onClick }) => (
  <section>
    <SignedOutHeader />
    <div className="main-container">
      <div className="signin-page">
        <h2 className="">{t('message')}</h2>
        <Button text={t('button')} action={onClick} type="primary" />
      </div>
    </div>
  </section>
);

export default translate('signin')(SignIn);
